import { render } from "./Employees.vue?vue&type=template&id=d1a1def0"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"
script.render = render

export default script